/*eslint-disable*/
import React from "react";
import { useTranslation } from 'react-i18next'


// components
import {
  Chip,
} from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
// constants


//styles


const SuccessBadge = () => {
  const { t } = useTranslation()
  return (
    <Chip icon={<CircleIcon style={{ fontSize: "small" }} />} label={t('upload-completed')} variant="outlined" style={{ backgroundColor: "#53CE76", color: "#FFF" }} />
  )
}

const InProgressBadge = () => {
  const { t } = useTranslation()
  return (
    <Chip icon={<CircleIcon style={{ fontSize: "small", color: "#004685" }} />} label={t('upload-in-progress')} variant="outlined" style={{ backgroundColor: "#69D0FF", color: "#004685" }} />
  )
}

const PartialProgressBadge = () => {
  const { t } = useTranslation()
  return (
    <Chip icon={<CircleIcon style={{ fontSize: "small", color: "#EB1700" }} />} label={t('upload-in-progress')} variant="outlined" style={{ color: "#EB1700" }} />
  )
}

const FailedBadge = () => {
  const { t } = useTranslation()
  return (
    <Chip icon={<CircleIcon style={{ fontSize: "small", color: "#EB1700" }} />} label={t('upload-failed')} variant="outlined" style={{ color: "#EB1700" }} />
  )
}


function StatusBadge({ status }) {

  if (status === "processed" || status === "completed") {
    return <SuccessBadge />
  }
  if (status === "partial-processed") {
    return <PartialProgressBadge />
  }
  if (status === "failed" || status === "failed-validation") {
    return <FailedBadge />
  }
  return (
    <InProgressBadge />
  );
}

export default StatusBadge;
